// Libs
import { sortBy } from "lodash";
import { useState } from "react";

// Apis

// Types
import type { SFUser } from "src/types/sales-force";

// Utils
import { useTranslation } from "src/design-system/core/TranslationContext";
import { useSideMenuAdminMonitoringStyles } from "src/views/admin/AdminView/admin-monitoring/SideMenuAdminMonitoring.styles";
import {
    ADMIN_MONITORING_TRANSLATION_NAMESPACE,
    SIDE_MENU_TK,
} from "src/views/admin/AdminView/admin-monitoring/config";

// Components
import { Autocomplete, Card, TextField } from "@mui/material";
import { IoAlertCircleOutline, IoWarningOutline } from "react-icons/io5";
import type { OrganizationSideMenu } from "src/layouts/AdminMonitoringLayout";
import { AccordionOrganizationMenu } from "src/views/admin/AdminView/admin-monitoring/AccordionOrganizationMenu";
import { RefreshOrganizationMonitoring } from "src/views/admin/AdminView/admin-monitoring/RefreshOrganization";
export function SideMenuAdminMonitoring({
    organizationWithErrorList,
    organizationWithAlertList,
    SFUsers,
}: {
    organizationWithErrorList: OrganizationSideMenu[];
    organizationWithAlertList: OrganizationSideMenu[];
    SFUsers: SFUser[];
}): JSX.Element {
    const classes = useSideMenuAdminMonitoringStyles();
    const { t } = useTranslation(`${ADMIN_MONITORING_TRANSLATION_NAMESPACE}:${SIDE_MENU_TK}`);
    const [selectedUser, setSelectedUser] = useState<SFUser>(null);
    const handleChange = (_, value) => setSelectedUser(value);

    return (
        <>
            <Autocomplete
                value={selectedUser}
                multiple={false}
                renderInput={(params) => <TextField {...params} label={t("account-owner")} />}
                options={SFUsers ? sortBy(SFUsers, "name") : []}
                onChange={handleChange}
                getOptionLabel={({ name }) => name}
            />

            {organizationWithErrorList.length > 0 && (
                <AccordionOrganizationMenu
                    defaultOpen={true}
                    organizationList={organizationWithErrorList.filter((orga) =>
                        selectedUser?.id ? orga?.ownerId === selectedUser?.id : true
                    )}
                    title={t("emergency")}
                    icon={<IoAlertCircleOutline className={classes.errorIconSideMenu} />}
                />
            )}
            {organizationWithAlertList.length > 0 && (
                <AccordionOrganizationMenu
                    defaultOpen={true}
                    organizationList={organizationWithAlertList.filter((orga) =>
                        selectedUser?.id ? orga?.ownerId === selectedUser?.id : true
                    )}
                    title={t("alert")}
                    icon={<IoWarningOutline className={classes.warningIconSideMenu} />}
                />
            )}
            <Card>
                <RefreshOrganizationMonitoring />
            </Card>
        </>
    );
}
